// [86bbumedw] P1 — display-only role names (Option A, scope-based). The DB GateAcl ids and sName
// are UNCHANGED; this maps the id -> the label shown in the UI. ONE source of truth for every role
// render (AppShell header, Users tree/minipill/dropdown/filter, User Log pill).
//   100 Super · 1 Account Admin (was "master") · 2 Site Admin (was "admin") · 3 Guard · 4 Viewer (was "client")
export const ROLE_LABEL = { 100: 'Super', 1: 'Account Admin', 2: 'Site Admin', 3: 'Guard', 4: 'Viewer' };

export const roleLabel = (aclId) => (ROLE_LABEL[aclId] != null ? ROLE_LABEL[aclId] : '');

// Plural form for the role-filter counts ("Site Admins (3)"). Simple +s covers every label above.
export const rolePlural = (aclId) => { const l = roleLabel(aclId); return l ? l + 's' : l; };
